import { createAction, createReducer } from 'typesafe-actions';
import { combineReducers } from 'redux';
import { YaPaySession } from 'types/yandex-pay';

export const SET_YANDEX_SPLIT_SESSION = createAction('yandexSplit/SET_SESSION')<YaPaySession>();

export const RESET_YANDEX_SPLIT_SESSION = createAction('yandexSplit/RESET_SESSION')();

const session = createReducer<YaPaySession | null>(null)
  .handleAction(SET_YANDEX_SPLIT_SESSION, (_, { payload }) => payload)
  .handleAction(RESET_YANDEX_SPLIT_SESSION, (split) => {
    split?.destroy?.();
    return null;
  });

export const yandexSplit = combineReducers({
  session,
});
